import { Injectable } from '@angular/core';
import { TranslocoService } from '@jsverse/transloco';

export type LocaleOptionType = {
    name: string;
    value: string;
    numeralValue: string;
};

@Injectable({
    providedIn: 'root',
})
export class LocaleService {
    private readonly localeOptions = [
        {
            name: this.translocoService.translate('locale.english'),
            value: 'en',
            numeralValue: 'en-gb',
        },
        {
            name: this.translocoService.translate('locale.danish'),
            value: 'da',
            numeralValue: 'da-dk',
        },
        {
            name: this.translocoService.translate('locale.dutch'),
            value: 'nl',
            numeralValue: 'nl-nl',
        },
        {
            name: this.translocoService.translate('locale.japanese'),
            value: 'ja',
            numeralValue: 'ja',

        },
        {
            name: this.translocoService.translate('locale.norwegian'),
            value: 'nb',
            numeralValue: 'no',
        },
        {
            name: this.translocoService.translate('locale.swedish'),
            value: 'sv',
            numeralValue: 'da-dk',
        },
        {
            name: this.translocoService.translate('locale.french'),
            value: 'fr',
            numeralValue: 'fr',
        },
        {
            name: this.translocoService.translate('locale.spanish'),
            value: 'es',
            numeralValue: 'da-dk',
        },
        {
            name: this.translocoService.translate('locale.portuguese'),
            value: 'pt',
            numeralValue: 'da-dk',
        },
    ];

    constructor (private translocoService: TranslocoService) {}

    getLocaleOptions (): LocaleOptionType[] {
        return this.localeOptions;
    }

    getDefaultOption (): LocaleOptionType {
        return this.localeOptions[0]; // First option is English (default)
    }

    getNumeralValue (locale: string = ''): string {
        const option = this.localeOptions.find((opt) => opt.value === locale);
        return option?.numeralValue || 'en-gb';
    }
}
